import PropTypes from 'prop-types';

import {useSubscriber} from '@stubhub/pubsub-utils';

import {COOKIE_MODAL_EVENTS} from './utils/track-events';
import {cookieConsent} from './utils/track-utils';

const TrackListener = (props, {track}) => {
  const cookieModalTracking = {
    [COOKIE_MODAL_EVENTS.SET_VALUES]: ({values} = {}) => {
      cookieConsent(track, values);
    },
  };

  useSubscriber(COOKIE_MODAL_EVENTS.MAIN, cookieModalTracking);

  return null;
};

TrackListener.contextTypes = {
  /** Object that contains tracking functions necessary for sending the event */
  track: PropTypes.object,
};

TrackListener.displayName = 'CookieModalTrackListener';

export default TrackListener;
